import React, { Component, PropTypes } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';

class Footer extends Component {
  static propTypes = {
    footerAdhesionOffset: PropTypes.bool,
    backgroundColor: PropTypes.string,
    backgroundUri: PropTypes.string,
    textColor: PropTypes.string,
    linkColor: PropTypes.string,
    privacyStatementUri: PropTypes.string,
    termsOfServiceUri: PropTypes.string,
    footerLinks: PropTypes.array
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    footerAdhesionOffset: false,
    backgroundColor: '#FFF',
    textColor: '#000',
    linkColor: '#FFF',
    footerLinks: []
  }

  render() {
    const {
      config: {
        affiliate: {
          displayName: affiliateDisplayName = ''
        } = {}
      }
    } = this.context;

    const {
      footerAdhesionOffset,
      backgroundColor,
      textColor,
      linkColor,
      privacyStatementUri,
      termsOfServiceUri,
      footerLinks
    } = this.props;

    const linkStyle = { color: linkColor };

    const privacyPolicy = <a href={privacyStatementUri} target="_blank" style={linkStyle} rel="noopener noreferrer"> Privacy Policy</a>;
    const termsOfService = <a href={termsOfServiceUri} target="_blank" style={linkStyle} rel="noopener noreferrer"> Terms of Service</a>;
    const adChoices = <a href="http://www.aboutads.info/choices" target="_blank" style={linkStyle} rel="noopener noreferrer"> Ad Choices</a>;

    const className = classNames('Footer',
      { 'adhesion': footerAdhesionOffset }
    );

    return (
      <div className={className} style={{backgroundColor, color: textColor}}>
        <Grid>
          <Row>
            <Col xs={12}>
              <div className="Footer-copyrightText">
                All content &copy; copyright { affiliateDisplayName }.
              </div>
              <a className="Footer-franklyLink" href="http://www.franklyinc.com" target="_blank">
                <PoweredByFranklyIcon />
              </a>
              { footerLinks.length &&
                <div className="Footer-footerLinks">
                  { footerLinks.map((item, index) => {
                    const content = [];
                    content.push(item.destinationUri ? <a style={linkStyle} href={item.destinationUri}>{item.text}</a> : <span>{item.text}</span>);
                    if (index < footerLinks.length - 1) {
                      content.push(<span>|</span>);
                    }

                    return content;
                  })}
                </div>
              }
              <div className="Footer-rightsText">
                All Rights Reserved. For more information on this site, please read our {privacyPolicy}, {termsOfService}, and {adChoices}.
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

/**
 * Class representing the 'Powered by Frankly' SVG icon
 */
class PoweredByFranklyIcon extends Component {
  render() {
    return (
      <div className="PoweredByFranklyIcon">
        <svg x="0px" y="0px" width="110.1px" height="16.5px" viewBox="0 0 110.1 16.5" >
          <g>
            <g id="Mark_1_">
              <g>
                <g>
                  <path className="PoweredByFranklyIcon-path" d="M108.3,2.4h-7c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h7c0.7,0,1.2,0.5,1.2,1.2S109,2.4,108.3,2.4z"/>
                </g>
              </g>
              <g>
                <g>
                  <path className="PoweredByFranklyIcon-path" d="M108.9,6.8h-3c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h3c0.7,0,1.2,0.5,1.2,1.2S109.6,6.8,108.9,6.8z"/>
                </g>
              </g>
              <g>
                <g>
                  <circle className="PoweredByFranklyIcon-path" cx="104.8" cy="10" r="1.3"/>
                </g>
              </g>
            </g>
            <g id="Word_1_">
              <g>
                <path className="PoweredByFranklyIcon-path" d="M59.8,3.4c0.2,0,0.3-0.1,0.3-0.3V2.2c0-0.2-0.1-0.3-0.3-0.3l-0.6,0c-1.5,0-2.7,1.2-2.7,2.7v9
                  c0,0.2,0.1,0.3,0.3,0.3h1c0.2,0,0.3-0.1,0.3-0.3V7.2h1.6c0.2,0,0.3-0.1,0.3-0.3V5.9c0-0.2-0.1-0.3-0.3-0.3h-1.6l0-1
                  c0-0.1,0-0.1,0-0.2c0.1-0.6,0.6-1,1.2-1H59.8z"/>
              </g>
              <g>
                <path className="PoweredByFranklyIcon-path" d="M64.8,5.5c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.3,0-0.5,0c-0.5,0.1-0.9,0.3-1.2,0.5V5.9c0-0.2-0.1-0.3-0.3-0.3
                  h-1c-0.2,0-0.3,0.1-0.3,0.3v2.9v0.9v3.8c0,0.2,0.1,0.3,0.3,0.3h1.1c0.2,0,0.3-0.1,0.3-0.3V9V8.7c0-0.9,0.7-1.6,1.6-1.6
                  c0.2,0,0.3-0.2,0.3-0.3V5.7C64.9,5.6,64.8,5.6,64.8,5.5z"/>
              </g>
              <g>
                <path className="PoweredByFranklyIcon-path" d="M72.6,6.7c-0.8-0.8-1.8-1.3-2.9-1.3c-0.1,0-0.2,0-0.2,0c-1.1,0-2.1,0.4-2.9,1.2c-0.9,0.9-1.3,1.9-1.3,3.1
                  c0,1.1,0.4,2.2,1.2,3c0.8,0.8,1.8,1.3,2.9,1.3c0.1,0,0.1,0,0.2,0c1,0,1.8-0.3,2.6-0.9v0.4c0,0.2,0.1,0.3,0.3,0.3h1
                  c0.2,0,0.3-0.1,0.3-0.3V9.8v0C73.8,8.6,73.4,7.6,72.6,6.7z M69.5,12.4c-1.4,0-2.6-1.2-2.6-2.7c0-1.4,1.2-2.6,2.6-2.6
                  s2.6,1.2,2.6,2.6C72.1,11.2,71,12.4,69.5,12.4z"/>
              </g>
              <g>
                <path className="PoweredByFranklyIcon-path" d="M78.7,5.4c-1.1,0-1.9,0.4-2.7,1.1C75.3,7.2,75,8.1,75,9.2v4.4c0,0.2,0.1,0.3,0.3,0.3h1
                  c0.2,0,0.3-0.1,0.3-0.3v-4c0-1.1,0.2-1.5,0.6-1.9C77.6,7.2,78.1,7,78.7,7c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.9v4
                  c0,0.2,0.1,0.3,0.3,0.3h1c0.2,0,0.3-0.1,0.3-0.3V9.2c0-1.1-0.4-2-1.1-2.7C80.6,5.8,79.7,5.4,78.7,5.4z"/>
              </g>
              <g>
                <path className="PoweredByFranklyIcon-path" d="M87.2,9.8L90,6.1C90,6,90.1,5.9,90,5.8c-0.1-0.1-0.2-0.2-0.3-0.2h-1.3c-0.1,0-0.2,0-0.3,0.1l-3,3.8V3.2
                  c0-0.2-0.1-0.3-0.3-0.3h-1.1c-0.2,0-0.3,0.1-0.3,0.3v10.3c0,0.2,0.1,0.3,0.3,0.3H85c0.2,0,0.3-0.1,0.3-0.3v-1.3l0.9-1.1l2.2,2.7
                  c0.1,0.1,0.2,0.1,0.2,0.1H90c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0-0.2,0-0.3L87.2,9.8z"/>
              </g>
              <g>
                <path className="PoweredByFranklyIcon-path" d="M92.6,2.9h-1c-0.2,0-0.3,0.1-0.3,0.3v10.3c0,0.2,0.1,0.3,0.3,0.3h1c0.2,0,0.3-0.1,0.3-0.3V3.2
                  C92.9,3.1,92.7,2.9,92.6,2.9z"/>
              </g>
              <g>
                <path className="PoweredByFranklyIcon-path" d="M101.6,5.7c-0.1-0.1-0.2-0.1-0.3-0.1h-1.1c-0.1,0-0.2,0.1-0.3,0.2l-2.3,5.3l-2.1-5.3c0-0.1-0.2-0.2-0.3-0.2
                  h-1.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.1,0.2,0,0.3l2.9,7.3l-1.1,2.8c0,0.1,0,0.2,0,0.3c0.1,0.1,0.2,0.1,0.3,0.1H97
                  c0.1,0,0.2-0.1,0.3-0.2L101.6,6C101.7,5.9,101.6,5.8,101.6,5.7z"/>
              </g>
            </g>
          </g>
          <g>
            <path className="PoweredByFranklyIcon-path" d="M0,6.5h1.8c1.2,0,1.7,0.7,1.7,1.7c0,1.1-0.7,1.6-1.8,1.6H1v1.7H0V6.5z M1.6,8.9c0.6,0,0.9-0.3,0.9-0.8
              c0-0.5-0.3-0.8-0.9-0.8H1v1.5H1.6z"/>
            <path className="PoweredByFranklyIcon-path" d="M4.8,8.9c0-1.5,1-2.5,2.5-2.5c1.5,0,2.5,1,2.5,2.5c0,1.5-1.1,2.5-2.5,2.5C5.8,11.5,4.8,10.4,4.8,8.9z M8.8,8.9
              c0-0.9-0.6-1.6-1.5-1.6C6.4,7.3,5.8,8,5.8,8.9c0,0.9,0.6,1.6,1.5,1.6C8.2,10.6,8.8,9.9,8.8,8.9z"/>
            <path className="PoweredByFranklyIcon-path" d="M17.6,6.5l-1.6,5h-0.9l-0.9-3.5h0l-1,3.5h-0.9l-1.6-5h1l1,3.4h0l0.9-3.4h1l0.9,3.4h0l1-3.4H17.6z"/>
            <path className="PoweredByFranklyIcon-path" d="M18.9,6.5h3.2v0.9h-2.2v1.2h1.8v0.9h-1.8v1.2h2.4v0.9h-3.3V6.5z"/>
            <path className="PoweredByFranklyIcon-path" d="M26.4,11.4l-1.1-1.7h-0.6v1.7h-1v-5h1.9c1.2,0,1.7,0.7,1.7,1.7c0,0.8-0.4,1.3-1,1.5v0l1.2,1.8H26.4z M24.7,8.9
              h0.7c0.6,0,0.9-0.3,0.9-0.8S26,7.3,25.5,7.3h-0.7V8.9z"/>
            <path className="PoweredByFranklyIcon-path" d="M29,6.5h3.2v0.9h-2.2v1.2h1.8v0.9h-1.8v1.2h2.4v0.9H29V6.5z"/>
            <path className="PoweredByFranklyIcon-path" d="M33.8,6.5h1.6C37,6.5,38,7.5,38,9c0,1.5-1,2.5-2.6,2.5h-1.7V6.5z M35.4,10.6c1,0,1.6-0.7,1.6-1.6
              c0-0.9-0.6-1.6-1.5-1.6h-0.7v3.2H35.4z"/>
            <path className="PoweredByFranklyIcon-path" d="M45.7,10.1c0,0.8-0.5,1.4-1.6,1.4H42v-5h1.8c1.1,0,1.6,0.4,1.6,1.2c0,0.4-0.2,0.9-0.7,1.1v0
              C45.3,9,45.7,9.4,45.7,10.1z M43,8.5h0.7c0.4,0,0.7-0.2,0.7-0.6c0-0.3-0.2-0.6-0.8-0.6H43V8.5z M44.6,9.9c0-0.4-0.3-0.6-0.9-0.6H43
              v1.3h0.8C44.3,10.6,44.6,10.4,44.6,9.9z"/>
            <path className="PoweredByFranklyIcon-path" d="M50.8,6.5l-1.7,2.8v2.2h-1V9.2l-1.6-2.8h1.1l1,1.8h0l1-1.8H50.8z"/>
          </g>
        </svg>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./app/components/core/Footer.js